import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import energyIcon from "../../../../../assets/new-product-detail-cats/sub-icons/prod-energy-icon.svg";
import { useTranslation } from "react-i18next";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import {
  getProductEquipment,
  createSystemBoundaryProductEquipment,
} from "../../../../../apis/Product/ProductEquipmentApi";

const ProdEnergyIcon = () => (
  <img src={energyIcon} alt="Energy Icon" width={76} height={76} />
);

const ProdEnergyHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalProdItem, setTotalProdItem] = useState([]);
  const [systemBoundaryItem, setSystemBoundaryItem] = useState("");

  useEffect(() => {
    getProductEquipment({
      id: productId,
      setProdInv: setTotalProdItem,
      setSystemBoundary: setSystemBoundaryItem,
    });
  }, [productId]);
  return (
    <CategoryComponent
      show={show}
      className={`prod-energy-category ${className || ""}`}
      leftBoxProps={{
        icon: <ProdEnergyIcon />,
        title: t("ENERGY"),
        description: t("PROD_ENERGY_DESC"),
        productId: productId,
        isSystemBoundary: true,
        systemBoundary: systemBoundaryItem,
        setSystemBoundary: setSystemBoundaryItem,
        createSystemBoundaryFunc: createSystemBoundaryProductEquipment,
        isManufacturing: true,
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: t("EMISSIONS"),
                subitems: [
                  {
                    value: `${
                      totalProdItem
                        ? handleToFixedNum(
                            totalProdItem,
                            totalProdItem?.total_carbon
                          )
                        : "xx"
                    } (tCO₂e)`,
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalProdItem?.updated_at
          ? formatDate(totalProdItem?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default ProdEnergyHeader;
